import Select, {ListOption, LocationIcon} from "@/Atoms/Select/Select";
import React from "react";
import debounce from "@/helpers/debounce";
import axios from "axios";
import {relativeRoute} from "@/helpers/relativeRoute";
import {MultiValueProps, components} from "react-select";


export default (props: any) => {


  const debouncedPlaces = debounce((inputValue: string) => {
    return new Promise<ListOption[]>(async (resolve) => {
      const response = await axios.get(relativeRoute('region-search') + '?search=' + inputValue)
      resolve(response.data)
    });
  }, 500, {leading: true})
  const loadOptions = (inputValue: string) => {
    return debouncedPlaces(inputValue);
  }
  const OptionComponent = (props: any) => {
    const { data, innerRef, innerProps } = props

    return <div ref={innerRef} {...innerProps} className={'option'}>
      <div className={'icon'}>
        <LocationIcon type={data.type} />
      </div>
      <div className={'wrapper'}>
        <div className={'title'}>{data.label}</div>
        <div className={'sub'}>{data.description}</div>
      </div>
    </div>
  }

  const MultiValueComponent = (props: MultiValueProps<any>) => {

    const option = props.data
    let title = option.label
    switch (option.type) {
      case 'municipality': title = `Gem. ${title}`; break;
      case 'province': title = `Prov. ${title}`; break;
    }
    return <components.MultiValue {...props}>
      <div title={option.description}>
        {title}
      </div>
    </components.MultiValue>
  }
  return <Select
    {...props}
    name={'place'}
    isAsync
    isMulti
    isClearable
    placeholder={'Zoek naar één of meer plaatsen of gebieden'}
    noOptionsMessage={() => 'Geen zoekresultaten'}
    loadingMessage={() => 'Bezig met zoeken...'}
    loadOptions={loadOptions}
    components={{
      DropdownIndicator: () => null,
      IndicatorSeparator: () => null,
      Option: OptionComponent,
      MultiValue: MultiValueComponent
    }}


  />
}